import { DocumentStatus, NewPostInput } from '../interfaces/post.interface';

export const NewPostInputInitialState: NewPostInput = {
  id: '',
  article: false,
  userId: undefined,
  username: undefined,
  textBlocks: undefined,
  status: DocumentStatus.DRAFT,
  categories: undefined,
  parentPostId: undefined,
};
